import React, { ReactElement } from 'react';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import CustomTable from '../../../tables/CustomTable';

interface restricedCompaniesTableProps {
  restrictedCompanies: any;
  selectedOption: string | null;
}

interface IRestricedCompanies {
  name: string;
  aliasNames: string;
  listingStartDate: string;
  comments: string;
}

function buildRestrictedCompaniesTableData(restrictedCompanies: any) {
  if (!restrictedCompanies) return [];
  if (!restrictedCompanies.data.length) return [];

  const optionData =
    typeof restrictedCompanies.data[0] === 'object'
      ? Object.values(restrictedCompanies.data[0])
      : restrictedCompanies.data[0];

  const companiesData: IRestricedCompanies[] = [];
  // Create data for the table containing required columnns.
  optionData.forEach((value: any) => {
    companiesData.push({
      name: value.first_name,
      aliasNames: tryParseJson(value.alias_names),
      listingStartDate: value.listing_start_date,
      comments: value.comments,
    });
  });
  return companiesData;
}

function tryParseJson(value: any) {
  // Function to parse a json string (if the string is a json object)
  // If not then just return the object as is.
  let returnValue = null;
  try {
    returnValue = decodeURIComponent(JSON.parse(value));
  } catch (e) {
    returnValue = value;
  }
  return returnValue;
}

const detailColumns: CustomColumn<IRestricedCompanies>[] = [
  {
    title: 'Name',
    field: 'name',
    cellStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      width: '15%',
    },
    headerStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      width: '20%',
    },
  },
  {
    title: 'Alias Names',
    field: 'aliasNames',
    cellStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      width: '30%',
    },
    headerStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      width: '30%',
    },
  },
  {
    title: 'Comments',
    field: 'comments',
    cellStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      width: '40%',
    },
    headerStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      width: '40%',
    },
  },
  {
    title: 'Listing Start Date',
    field: 'listingStartDate',
    cellStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      width: '15%',
    },
    headerStyle: {
      textAlign: 'left',
      paddingLeft: '1rem',
      width: '10%',
    },
    defaultSort: 'desc',
    render: (rowData: IRestricedCompanies) =>
      rowData.listingStartDate ? rowData.listingStartDate.substring(0, 10) : '',
  },
];

function RestrictedCompaniesTable(
  props: restricedCompaniesTableProps,
): ReactElement {
  const { restrictedCompanies, selectedOption } = props;

  const tableData = buildRestrictedCompaniesTableData(restrictedCompanies);

  return (
    <CustomTable<IRestricedCompanies>
      columns={detailColumns}
      showToolbar
      data={tableData}
      title={'Restricted Companies'}
      options={{
        paging: tableData.length > 50,
        pageSize: 50,
        pageSizeOptions: [50, 100, 200, 500, 1000],
        search: true,
        exportButton: true,
        emptyRowsWhenPaging: false,
      }}
      additionalDetailForPdf={`${selectedOption} Restriction List`}
    />
  );
}

export default RestrictedCompaniesTable;
